import { Fragment } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { PhoneApps } from '~/shared';
import { WeatherWidget } from '../../components/WeatherWidget';
import { appsIcons, appsNames, mainApps } from '../../models/PhoneApp';
import { wallpapers } from '../../models/Wallpaper';
import { appComponents, setActiveApp, useLayoutDispatch } from '../../redux';
import {
	StyledApp,
	StyledAppsContainer,
	StyledContainer,
	StyledNotificationCount,
} from './PhoneMain.styled';

const PhoneMain = () => {
	const dispatch = useLayoutDispatch();
	const settings = useObservable(rage.phone.getSettings());
	const isBankAppAvailable = useObservable(rage.bank.getIsBankAppAvailable());
	const notificationsCount = useObservable(rage.phone.getNotificationsCount());

	const handleAppClick = (app: PhoneApps) => {
		if (app === PhoneApps.CAMERA) {
			rage.phone
				.openCamera()
				.catch((err) => rage.notifications.showException(err));
		} else if (app === PhoneApps.GPS) {
			rage.phone
				.openGps()
				.catch((err) => rage.notifications.showException(err));
		} else if (app === PhoneApps.ADS) {
			rage.phone
				.openAds()
				.catch((err) => rage.notifications.showException(err));
		}

		if (appComponents[app]) {
			dispatch(setActiveApp(app));
		}
	};

	const filteredApps = mainApps.filter((app) => {
		if (app === PhoneApps.BANK) {
			return isBankAppAvailable;
		}
		return true;
	});

	return (
		<StyledContainer
			style={{
				backgroundImage: `url(${wallpapers[settings.wallpaperIndex]})`,
			}}
		>
			<StyledAppsContainer>
				{filteredApps.map((app, index) => (
					<Fragment key={app}>
						<StyledApp
							onClick={() => {
								handleAppClick(app);
								playSound(Sound.ClickButton);
							}}
							onMouseEnter={() => playSound(Sound.LinkCursor)}
						>
							<img src={appsIcons[app]} alt={app} />
							<Text>{appsNames[app]}</Text>
							{notificationsCount.find((item) => item.app === app)?.count ? (
								<StyledNotificationCount>
									<Text>
										{notificationsCount.find((item) => item.app === app)?.count}
									</Text>
								</StyledNotificationCount>
							) : null}
						</StyledApp>
						{index === 1 && <WeatherWidget />}
					</Fragment>
				))}
			</StyledAppsContainer>
		</StyledContainer>
	);
};

export { PhoneMain };
